import {
    IBoletoDeParcela,
    IBoletoPDF,
    IDadosFinanceirosRequest,
    IParcelaBoletos,
    IParcelaDadosFinanceiroGenerico,
    IParcelas,
} from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { TIPO_ERP } from "../../../Interfaces/Organizacao/Organizacao";

import {
    BaixarBoletoPDFESolutionService,
    BuscarParcelasAReceberServices,
    GerarPdfESolutionService,
    GetBoletoPDFService,
    ListarParcelasAbertasDadosFinanceirosService,
    ListarParcelasAbertasUAU,
    ListarParcelasBoletosService,
    ListarParcelasRecebidasDadosFinanceirosService,
    ListarParcelasSerasaService,
} from "../../../Services/Cobranca/Parcelas/ParcelasServices";
import { groupBy } from "../../../Tools/ProcessingTools";

import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function ListarParcelasAbertasUAUController(
    requestBody: IParcelas
) {
    const Response = await ListarParcelasAbertasUAU(requestBody)
        .then((response) => {
            return response.data;
        })
        .then((res) =>
            res.map((parcela) => ({
                ...parcela,
                ID_CHAVE_PARCELA: `${requestBody.NR_EMPRESA}_${requestBody.DS_OBRA}_${requestBody.NR_VENDA}_${parcela.NR_PARCELA}_${parcela.DS_TIPO_PARCELA}_${parcela.NR_PARCELA_GERAL}`,
            }))
        )
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}
export async function BuscarParcelasAReceberController(requestBody: IParcelas) {
    const Response = await BuscarParcelasAReceberServices(requestBody)
        .then((response) => {
            return response.data;
        })
        .then((parcelas) => {
            return parcelas.map((parcela) => ({
                ...parcela,
                ID_CHAVE_PARCELA: `${requestBody.NR_EMPRESA}_${requestBody.DS_OBRA}_${requestBody.NR_VENDA}_${parcela.NR_PARCELA}_${parcela.DS_TIPO_PARCELA}_${parcela.NR_PARCELA_GERAL}`,
            }));
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}
export async function ListarParcelasBoletosController(requestBody: IParcelas) {
    const Response = await ListarParcelasBoletosService(requestBody)
        .then((response) => {
            return response.data;
        })
        .then((parcelas) =>
            parcelas.map((parcela) => ({
                ...parcela,
                ID_CHAVE_PARCELA: `${requestBody.NR_EMPRESA}_${requestBody.DS_OBRA}_${requestBody.NR_VENDA}_${parcela.NumParc_Prc}_${parcela.Tipo_Prc}_${parcela.NumParcGer_Prc}`,
            }))
        )
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function GetBoletoPDFController(requestBody: IBoletoPDF) {
    const Response = await GetBoletoPDFService(requestBody)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function BaixarBoletoPDFESolutionController(
    NR_CPF: string,
    requestBody: string[]
) {
    return Controller(BaixarBoletoPDFESolutionService(NR_CPF, requestBody));
}

export async function GerarPdfESolutionController(
    NR_CPF: string,
    requestBody: string[]
) {
    return Controller(GerarPdfESolutionService(NR_CPF, requestBody));
}

export async function ListarParcelasAbertasDadosFinanceirosController(
    requestBody: IDadosFinanceirosRequest,
    antecipacao: boolean
) {
    const Response = await ListarParcelasAbertasDadosFinanceirosService(
        requestBody,
        antecipacao
    )
        .then((response) => {
            return response.data;
        })
        .then((res) =>
            res.map((parcela) => ({
                ...parcela,
                ID_CHAVE_PARCELA: `${requestBody.ID_CHAVE_ERP}_${parcela.NumParc_Prc}_${parcela.Tipo_Prc}_${parcela.NumParcGer_Prc}`,
            }))
        )
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function ListarParcelasRecebidasDadosFinanceirosController(
    ID_CHAVE_ERP: string
) {
    const Response = await ListarParcelasRecebidasDadosFinanceirosService(
        ID_CHAVE_ERP
    )
        .then((response) => {
            return response.data;
        })
        .then((res) => ({
            ...res,
            LISTA_PARCELAS_RECEBIDAS_COBRANCA_DTO:
                res.LISTA_PARCELAS_RECEBIDAS_COBRANCA_DTO.map((parcela) => ({
                    ...parcela,
                    ID_CHAVE_PARCELA: `${parcela.Empresa_rec}_${parcela.Obra_Rec}_${parcela.NumVend_Rec}_${parcela.NumParc_Rec}_${parcela.Tipo_Rec}_${parcela.NumParcGer_Rec}`,
                })),
        }))
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });
    return Response;
}

export async function ListarParcelasExtratoClienteCompleto(
    req: IDadosFinanceirosRequest,
    antecipacao: boolean
) {
    const [parcelasAbertas, parcelasRecebidas] = await Promise.all([
        ListarParcelasAbertasDadosFinanceirosController(
            {
                ID_CHAVE_ERP: req.ID_CHAVE_ERP,
                DT_CALCULO: new Date().toISOString(),
            },
            false
        ),
        ListarParcelasRecebidasDadosFinanceirosController(req.ID_CHAVE_ERP),
    ]);

    const parcelas: Array<IParcelaDadosFinanceiroGenerico> =
        parcelasRecebidas.LISTA_PARCELAS_RECEBIDAS_COBRANCA_DTO.map(
            (parcela) =>
                ({
                    DS_PARCELA: parcela.Tipo_Rec,
                    DS_TIPO_PARCELA: parcela.Tipo_Rec,
                    DT_VENCIMENTO: parcela.DataVenci_Rec,
                    DT_PAGAMENTO: parcela.Data_Rec,
                    NR_PARCELA: parcela.NumParc_Rec.toString(),
                    VL_SALDO_ATUAL: parcela.ValorSaldoAtual,
                    NR_DIAS: parcela.NumeroDiasAtraso,
                    VL_ORIGINAL: parcela.ValorConf_Rec,
                    VL_ACRESIMO: parcela.VlAcres_Rec,
                    VL_DESCONTO: parcela.VlDesconto_Rec,
                    VL_PAGAMENTO: parcela.VL_RECEBIDA,
                    DT_BASE: parcela.DataBase,
                    VL_LIQUIDO: parcela.ValorLiquido,
                    FL_PAGO: true,
                } as IParcelaDadosFinanceiroGenerico)
        );

    parcelas.push(
        ...parcelasAbertas.map((parcelaAberta) => ({
            DS_PARCELA: parcelaAberta.Descricao_par,
            DS_TIPO_PARCELA: parcelaAberta.Tipo_Prc,
            DT_VENCIMENTO: parcelaAberta.Data_Prc,
            NR_PARCELA: parcelaAberta.NumParc_Prc.toString(),
            VL_SALDO_ATUAL: parcelaAberta.ValorReaj,
            DT_BASE: parcelaAberta.DataBase,
            VL_ORIGINAL: parcelaAberta.Valor_Prc,
            NR_DIAS: parcelaAberta.NumeroDiasAtraso,
        }))
    );

    return parcelas;
}

export async function GetArquivosBoletosDeListaParcela(
    lstParcelasBoletos: Array<IParcelaBoletos>,
    COD_ERP_INTEGRACAO: TIPO_ERP,
    fileNameGetter?: (bol: IBoletoDeParcela) => string,
    nrCpfCliente?: string
) {
    // agrupando por boleto
    const ajkshgasd = Array.from(
        groupBy(
            lstParcelasBoletos,
            (p) => `${p.Boleto?.Banco_Bol}_${p.Boleto?.SeuNum_Bol}`
        ).values()
    );

    let lstParcelasAgrupadasPorBoleto: IParcelaBoletos[] = [];
    for (let i = 0; i < ajkshgasd.length; i++) {
        const grupoDeParcelas = ajkshgasd[i];
        if (grupoDeParcelas[0]?.Boleto)
            lstParcelasAgrupadasPorBoleto.push(grupoDeParcelas[0]!);
    }

    if (lstParcelasAgrupadasPorBoleto) {
        return Promise.all(
            lstParcelasAgrupadasPorBoleto.map(async (parcelaComBoleto) => {
                const bol = parcelaComBoleto.Boleto!;
                if (!bol.BoletoBase64)
                    await GetBoletoPDFController({
                        ...parcelaComBoleto,
                        ...bol,
                        nrCpfCliente: nrCpfCliente,
                    }).then((res) => (bol.BoletoBase64 = res));

                const mimeType =
                    COD_ERP_INTEGRACAO === "INFORMAKON"
                        ? "image/jpeg"
                        : "application/pdf";

                const blob = await fetch(
                    `data:${mimeType};base64,${bol.BoletoBase64}`
                ).then((r) => r.blob());
                if (fileNameGetter)
                    return new File([blob], fileNameGetter(bol), {
                        type: mimeType,
                    });
                else return blob;
            })
        );
    }
}

export function ListarParcelasSerasaController(idChaveERP: string) {
    return Controller(ListarParcelasSerasaService(idChaveERP));
}
